module.exports = __webpack_public_path__ + "resources/img/facetec-dev-mode-watermark.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-dev-mode-watermark.png
// module id = 1447
// module chunks = 0